
const normalizeBase = (value = "") =>
    String(value).trim().replace(/\/+$/, "");

export const PUBLIC_S3_BASE = normalizeBase(
    process.env.REACT_APP_PUBLIC_S3_BASE ||
    "https://content.code-pro.app"
);

export const SITE_URL = normalizeBase(
    process.env.REACT_APP_SITE_URL
);

export const API_BASE_URL = normalizeBase(
    process.env.REACT_APP_API_BASE
);

export const ADMIN_API_BASE = `${API_BASE_URL}/v1/admin`;
export const BLOG_API_BASE = `${API_BASE_URL}/v1/blog`;
export const COURSE_API_BASE = `${API_BASE_URL}/v1/course`;
export const APP_API_BASE = `${API_BASE_URL}/v1/app`;
export const USER_API_BASE = `${API_BASE_URL}/v1/user`;

export function resolvePublicImageUrl(key?: string | null): string {
    if (!key) return "";

    const value = key.trim();

    if (/^(https?:\/\/|blob:|data:)/i.test(value)) {
        return value;
    }

    const base = (
        PUBLIC_S3_BASE || "https://content.code-pro.app"
    ).replace(/\/+$/, "");

    return `${base}/${value.replace(/^\/+/, "")}`;
}